import { render, staticRenderFns } from "./DashboardLibrary.vue?vue&type=template&id=6104a1d8"
import script from "./DashboardLibrary.vue?vue&type=script&lang=ts"
export * from "./DashboardLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports